import React from 'react';
import { View } from 'react-native';
import { SkeletonBone } from '../SkeletonBone';

interface SkeletonSectionProps {
  headerWidth?: number | `${number}%`;
  headerHeight?: number;
  gap?: number;
  children: React.ReactNode;
}

export const SkeletonSection: React.FC<SkeletonSectionProps> = React.memo(({
  headerWidth = '40%',
  headerHeight = 18,
  gap = 12,
  children,
}) => (
  <View style={{ gap }}>
    <SkeletonBone width={headerWidth} height={headerHeight} borderRadius={4} />
    {children}
  </View>
));

SkeletonSection.displayName = 'SkeletonSection';
